export const scanner = {
  id: 'scan-B1',
  name: 'My Bedrock agent scanner',
  connectionName: 'Production Bedrock Connection',
  state: 'Completed'
};

export const agentsMock = [
  {
    agents: [
      {
        agentName: 'Legal contract review agent',
        agentVersion: 'v1.0.0',
        agentType: 'New asset',
        target: 'AWS Bedrock Agent',
        agentDescription:
          'AI-powered agent for reviewing legal contracts, identify key clauses, risks, and compliance issues with knowledge based integration.',
        platform: 'AWS Bedrock',
        foundation: 'anthropic.claude-3-5-sonnet-20241022-v2.0',
        agentId: 'AGENT21794',
        status: 'us-east-1',
        skills: [
          { name: 'Contract analysis' },
          { name: 'Risk Assesment' },
          { name: 'Compliance' }
        ]
      },
      {
        agentName: 'Customer support agent',
        agentVersion: 'v1.0.0',
        agentType: 'New asset',
        target: 'AWS Bedrock Agent',
        agentDescription:
          'Advanced multi-channel customer support agent with sentiment analysis, escalation logic, and integration with ticketing systems.',
        platform: 'AWS Bedrock',
        foundation: 'anthropic.claude-3-5-sonnet-20241022-v2.0',
        agentId: 'AGENT21794',
        status: 'us-east-1',
        skills: [
          { name: 'Contract analysis' },
          { name: 'Risk Assesment' },
          { name: 'Compliance' }
        ]
      }
    ]
  },
  {
    agents: [
      {
        agentName: 'Financial Report Analyzer',
        agentVersion: 'v2.1.0',
        agentType: 'Update available',
        target: 'AWS Bedrock Agent',
        agentDescription:
          'Enterprise financial analysis agent that processes quarterly reports, extracts KPIs, performs trend analysis with knowledge base of financial regulations.',
        agentNote:
          'Changes: New support for international GAAP standards, improved KPI extraction accuracy, added peer comparison analysis.',
        platform: 'AWS Bedrock',
        foundation: 'anthropic.claude-3-5-sonnet-20241022-v2.0',
        agentId: 'AGENT21794',
        status: 'us-east-1',
        skills: [
          { name: 'Contract analysis' },
          { name: 'Risk Assesment' },
          { name: 'Compliance' }
        ]
      }
    ]
  },
  {
    agents: [
      {
        agentName: 'Code Documentation Generator',
        agentVersion: 'v2.1.0',
        agentType: 'Missing from source',
        target: 'AWS Bedrock Agent',
        agentDescription: 'Legal customer support agent for older versions.',
        agentNote:
          'Impact Analysis: 1 published workflow(s) affected. Dependencies: Customer service bot.',
        platform: 'AWS Bedrock',
        foundation: 'anthropic.claude-3-5-sonnet-20241022-v2.0',
        agentId: 'AGENT21794',
        status: 'us-east-1',
        skills: [
          { name: 'Contract analysis' },
          { name: 'Risk Assesment' },
          { name: 'Compliance' }
        ]
      }
    ]
  },
  {
    agents: [
      {
        agentName: 'Email classificarion & routing agent',
        agentVersion: 'v2.1.0',
        agentType: 'Up to date',
        target: 'AWS Bedrock Agent',
        agentDescription:
          'Automated email classification agent that categorizes incoming emails, extracts intent, and routes to appropriate departments.',
        agentNote: '',
        platform: 'AWS Bedrock',
        foundation: 'anthropic.claude-3-5-sonnet-20241022-v2.0',
        agentId: 'AGENT21794',
        status: 'us-east-1',
        skills: [
          { name: 'Contract analysis' },
          { name: 'Risk Assesment' },
          { name: 'Compliance' }
        ]
      }
    ]
  },
  {
    agents: [
      {
        agentName: 'Code Documentation Generator',
        agentVersion: 'v2.1.0',
        agentType: 'Unsuccessful',
        target: 'AWS Bedrock Agent',
        agentDescription: 'Legal customer support agent for older versions.',
        agentNote: '',
        platform: 'AWS Bedrock',
        foundation: 'anthropic.claude-3-5-sonnet-20241022-v2.0',
        agentId: 'AGENT21794',
        status: 'us-east-1',
        skills: [
          { name: 'Contract analysis' },
          { name: 'Risk Assesment' },
          { name: 'Compliance' }
        ]
      },
      {
        agentName: 'Holiday Promotion Agent',
        agentVersion: 'v1.1.0',
        agentType: 'Unsuccessful',
        target: 'AWS Bedrock Agent',
        agentDescription: 'Temporary agent for holiday promotions (seasonal).',
        agentNote: '',
        platform: 'AWS Bedrock',
        foundation: 'anthropic.claude-3-5-sonnet-20241022-v2.0',
        agentId: 'AGENT21794',
        status: 'us-east-1',
        skills: [
          { name: 'Contract analysis' },
          { name: 'Risk Assesment' },
          { name: 'Compliance' }
        ]
      }
    ]
  }
];
